<template>
  <div class="code-input-wrapper form-content">
    <input
      v-for="(digit, index) in code"
      :key="index"
      :ref="el => inputRefs[index] = el"
      type="number"
      class="code-input"
      maxlength="1"
      v-model="code[index]"
      @input="handleInput(index)"
      @keydown.backspace="handleBackspace(index)"
      @paste="handlePaste($event)"
    />
  </div>
</template>
<script>export default {
  props: {
    userDigit: String,
  },
  data() {
    return {
      code: ['', '', '', ''],
      inputRefs: [],
    };
  },
  watch: {
    userDigit(newVal) {
      // newVal이 없거나 길이가 4 미만이면 빈칸('') 채워서 배열 길이 유지
      const arr = newVal ? newVal.split('') : [];
      while (arr.length < 4) arr.push('');
      this.code = arr.slice(0, 4);
    }
  },
  methods: {
    handleInput(index) {
      let value = this.code[index];

      if (!/^\d$/.test(value)) {
        this.code[index] = '';
        return;
      }

      if (index < this.code.length - 1) {
        this.inputRefs[index + 1].focus();
      }

      this.emitCombinedCode();
    },
    handleBackspace(index) {
      if (this.code[index] === '' && index > 0) {
        this.inputRefs[index - 1].focus();
      }

      this.emitCombinedCode();
    },
    handlePaste(event) {
      const paste = (event.clipboardData || window.clipboardData).getData('text');

      if (!/^\d{4}$/.test(paste)) {
        // 숫자 4자리가 아니면 무시
        event.preventDefault();
        return;
      }

      this.code = paste.split('').slice(0, 4);

      this.$nextTick(() => {
        // 붙여넣기 후 마지막 인풋으로 포커스
        this.inputRefs[5]?.focus();
      });

      this.emitCombinedCode();

      // 붙여넣기 기본 동작 방지
      event.preventDefault();
    },
    emitCombinedCode() {
      const joined = this.code.join('');
      this.$emit('update:userDigit', joined);
    },
  },
  mounted() {
    this.inputRefs[0]?.focus();
    if (this.userDigit) {
      this.code = this.userDigit.split('');
    }
  },
};
</script>
<style lang="scss">
  .form-content {
    margin-bottom: 10px;

  }

  .code-input-wrapper {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;
  }

  .code-input {
    width: 48px;
    height: 56px;
    text-align: center;
    font-size: 24px;
    border: 2px solid #ddd;
    border-radius: 8px;
  }
  .code-input:focus {
    border-color: #ff6600;
    outline: none;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox  */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
